import { Card, Typography } from "@mui/material";
import { Image } from "../types";

export default function ImageBox(props: Image) {
    return (
        <Card className={"flex flex-col mx-auto mt-5 p-2 w-4/5 lg:w-2/4"}>
            <img
                src={props.src} 
                style={{
                    width: props.width,
                    height: props.height
                }}
                alt=""
                loading="lazy"
                className='mt-10 mb-10 self-center'
            />
        </Card>
    )
}